import * as actionTypes from 'actions';

const initialState = {
  page: 1,
  name: '',
  login: '',
  email: '',
  type: 'ALL',
};

const registerUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGINATION_REGISTER_USER: {
      return { ...action.payload };
    }

    case actionTypes.CLEAR_PAGINATION_REGISTER_USER: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default registerUserReducer;
